export default "__VITE_ASSET__Wdx7dCQA__"